{
  "UnifiedNavigation": "Naviga in Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Seleziona un altro account organizzazione",
  "help": "Aiuto",
  "profile": "Profilo",
  "searchButton": "Cerca",
  "sidenavMenuCloseTooltip": "Chiudi menu",
  "sidenavMenuOpenTooltip": "Apri menu",
  "solutionSwitcher": "Passa a un’altra soluzione",
  "toggleSideNav": "Attiva/disattiva menu di navigazione laterale"
}
